import React from 'react';

import CheckboxCell from '../customgrid/CheckboxCell';

// eslint-disable-next-line import/prefer-default-export
export const columns = [
    {
        id: 'csaId',
        title: 'Monitoring CSAs'
    },
    {
        id: 'enabledToSend',
        title: '',
        width: 100,
        renderCell: row => (
            <CheckboxCell
                checked={ row.original.enabledToSend }
                onChange={ (checked) => {
                    row.column.getGridProps().setRowChecked(row.original.csaId, checked, row.original.id);
                } }
            />
        )
    }
];
